// extracted by mini-css-extract-plugin
export default {"costTagContainer":"IvD810YkIDq_rN7rW9ng","sourceTagContainer":"OoIhvQtVyugQgtYGtxPC"};